import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DateInput, NumberInput, DropdownInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { checkDateSet } from "data/lib/dates"

import { FormError_s } from "styles/form-styles"
import { SingleRowCarouselState_s, MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const TIDetailed = (props: {rowData: [], defaults: object, field: string, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyStatic = {
    amtType: _.get(props, "defaults.tiAmtType")
  }

  const emptyRecord = {
    date: null,
    amt: null,
  }

  const [data, setData] = useState<object|null>(props.rowData[props.field])
  const [items, setItems] = useState<Item_t[]>(initialItems && initialItems.length ? _.sortBy(initialItems.map((item, i) => { return {...item, i }}), "date") : [{...emptyRecord, i: 0}]);
  const [homogenous, setHomogenous] = useState<boolean>(true);

  function updateData(val:any, field:string|string[]):void {
    let nextData = _.cloneDeep(data || {})
    _.set(nextData, field, val)
    if(!nextData.items) _.set(nextData, 'items', [])
    completeUpdate(nextData)
  }

  function updateVal(val:any, field:string|string[]):void {
    let nextData = _.cloneDeep(data || {})

    if(items[field[0]][field[1]] === val) return
    items[field[0]][field[1]] = val
    if (field[1] === 'date') {
      let dateModeCheck = checkDateSet(val, items)
      setHomogenous(dateModeCheck.homogenous)
      _.set(nextData, 'dateMode', dateModeCheck.dateMode)
    }
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    _.set(nextData, 'items', strippedItems)
    completeUpdate(nextData)
  }

  function completeUpdate(nextData){
    if(nextData.state !== 'detailed') _.set(nextData, 'state', 'detailed')
    if(_.isNil(nextData.amtType)) _.set(nextData, 'amtType', _.get(props, "defaults.tiAmtType"))

    delete nextData.amt
    delete nextData.payout
    delete nextData.tenantCapitalNamedItemId

    setData(nextData)
    props.persist(nextData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let nextData = _.cloneDeep(data);
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest), "date");
    _.set(nextData, 'items', strippedItems);
    if (nextData.state !== 'detailed') _.set(nextData, 'state', 'detailed');
    props.persist(nextData, 'tidetail', props.rowData);
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateVal
  }

  useEffect(() => {
    if(_.get(props, 'rowData.tidetail.state') !== 'detailed'){
      setData(emptyStatic)
      setItems([{...emptyRecord, i: 0}]);
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('rentroll', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amount Type</label>
          <DropdownInput
            field="amtType"
            className="automated ti-amttype"
            data={data}
            attrs={attrs}
            default={props.defaults['tiAmtType']}
            options={['Amt', 'Amt/Area', '% of Rent', '% of Rent + Recovery', '% of Rent: Ignore Free', '% of Rent + Recovery: Ignore Free', '% of All Revenues']}
            persist={updateData}
          />
        </div>
      </SingleRowCarouselState_s>
      <br/>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div style={{width: '158px'}}>
              { i === 0 && <label>Date</label> }
              <DateInput className="automated" attrs={attrs} field={[`${row['i']}`, 'date']} {...params} allowRelative />
            </div>
            <div style={{width: '158px'}}>
              { i === 0 && <label>Amt</label> }
              <NumberInput
                className="automated billion-input"
                attrs={attrs}
                field={[`${row['i']}`, 'amt']}
                {...params}
                min={0}
                max={1000000000}
                readPrecision={4}
                writePrecision={4}
              />
            </div>
            <RowAddRemove emptyRecord={emptyRecord} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
      {!homogenous && <FormError_s>All dates must be either relative or absolute</FormError_s>}
    </div>
  )
}

export default TIDetailed
